import React from "react";

export const PDContactAuthorisedOfficerPopupCallSupportView: React.FC<{}> =
  () => {
    const clientNumber = "+918370969696";

    return (
      <div className="md:hidden flex items-center justify-center w-full md:w-auto">
        <a
          href={`tel:${clientNumber}`}
          className="w-full inline-flex items-center justify-center gap-2 border border-[#f26c1f] text-[#f26c1f] px-4 py-2 rounded-full text-[0.85rem] font-medium hover:bg-[#f26c1f] hover:text-white transition-colors"
        >
          <span>📞</span> <span>Call Support</span>
        </a>
      </div>
    );
  };
